// src/components/Service.js
import React from "react";

const vehicles = [
  {
    id: 1,
    name: "Pune Darshan Package",
    desc: "Discover Pune's famous temples, forts, gardens, and historical attractions with Rising Cab Service's comfortable Pune Darshan package.",
    image: "/images/services/Pune-Darshan-Packages.jpg",
    link: "/pune-darshan-packages",
  },
  {
    id: 2,
    name: "Pune Cab Booking Service",
    desc: "Rising Cab Service provides affordable local cab booking services in Pune with clean vehicles and professional drivers.",
    image: "/images/services/Pune-Cab-Booking-Service.jpg",
    link: "/pune-cab-booking-service",
  },
  {
    id: 3,
    name: "Online Cab Booking Service",
    desc: "Book your cab online with Rising Cab Service for instant confirmation and hassle-free local and outstation travel.",
    image: "/images/services/Online-Cab-Booking-Service.jpg",
    link: "/online-cab-booking-service",
  },
  {
    id: 4,
    name: "24/7 Available Cab Service",
    desc: "Rising Cab Service offers round-the-clock taxi services for airport transfers, local rides, and outstation journeys.",
    image: "/images/services/Available-Cab-Service.jpg",
    link: "/24-7-available-cab-service",
  },
  {
    id: 5,
    name: "One Way Cab Service",
    desc: "Enjoy affordable one-way cab services with Rising Cab Service and pay only for your journey without return charges.",
    image: "/images/services/One-Way-Cab-Service.jpg",
    link: "/one-way-cab-service",
  },
  {
    id: 6,
    name: "Pune Airport Cab Service",
    desc: "Reliable airport pickup and drop services by Rising Cab Service with punctual drivers and comfortable vehicles.",
    image: "/images/services/Pune-Airport-Cab-Service.jpg",
    link: "/pune-airport-cab-service",
  },
  {
    id: 7,
    name: "Pune Car Rental Services",
    desc: "Hire premium and budget cars from Rising Cab Service for local travel, business trips, and family outings.",
    image: "/images/services/Pune-Car-Rental-Services.jpg",
    link: "/pune-car-rental-services",
  },
  {
    id: 8,
    name: "Pune Mumbai Cab Service",
    desc: "Travel comfortably between Pune and Mumbai with Rising Cab Service's safe, affordable, and reliable taxi service.",
    image: "/images/services/Pune-Mumbai-Cab-Service.jpg",
    link: "/pune-mumbai-cab-service",
  },
  {
    id: 9,
    name: "Mumbai Pune Cab Service",
    desc: "Book a Mumbai to Pune cab with Rising Cab Service for a smooth, safe, and comfortable intercity travel experience.",
    image: "/images/services/Mumbai-Pune-Cab-Service.jpg",
    link: "/mumbai-pune-cab-service",
  },
  {
    id: 10,
    name: "Pune to Mumbai Airport Pickup Drop Services",
    desc: "Rising Cab Service offers dependable Pune to Mumbai Airport pickup and drop services with timely arrivals.",
    image: "/images/services/Pune-to-Mumbai-Airport-Pickup-Drop-Services.jpg",
    link: "/pune-to-mumbai-airport-pickup-drop-services",
  },
  {
    id: 11,
    name: "Shirdi Darshan Package",
    desc: "Visit the holy Shirdi Sai Baba Temple with Rising Cab Service's comfortable and affordable darshan package.",
    image: "/images/services/Shirdi-Darshan-Package.jpg",
    link: "/shirdi-darshan-package",
  },
  {
    id: 12,
    name: "Jyotirlinga Darshan Package",
    desc: "Experience a spiritual journey to sacred Jyotirlinga temples with Rising Cab Service's pilgrimage package.",
    image: "/images/services/Jyotirlinga-Darshan-Package.jpg",
    link: "/jyotirlinga-darshan-package",
  },
  {
    id: 13,
    name: "Lonavala Khandala Tour Package",
    desc: "Enjoy the scenic beauty of Lonavala and Khandala with Rising Cab Service's relaxing hill station tour package.",
    image: "/images/services/Lonavala-Khandala-Tour-Package.jpg",
    link: "/lonavala-khandala-tour-package",
  },
  {
    id: 14,
    name: "Ashtavinayak Darshan Package",
    desc: "Complete the sacred Ashtavinayak pilgrimage with Rising Cab Service's safe and comfortable travel service.",
    image: "/images/services/Ashtavinayak-Darshan-Package.jpg",
    link: "/ashtavinayak-darshan-package",
  },
  {
    id: 15,
    name: "Nashik Trimbakeshwar Package",
    desc: "Travel to Nashik and Trimbakeshwar Temple with Rising Cab Service for a memorable and peaceful pilgrimage.",
    image: "/images/services/Nashik-Trimbakeshwar-Package.jpg",
    link: "/nashik-trimbakeshwar-package",
  },
  {
    id: 16,
    name: "Mahabaleshwar Package",
    desc: "Plan your Mahabaleshwar holiday with Rising Cab Service and enjoy comfortable sightseeing and family travel.",
    image: "/images/services/Mahabaleshwar-Package.jpg",
    link: "/mahabaleshwar-package",
  },
  {
    id: 17,
    name: "Luxury Car Rental Service",
    desc: "Rising Cab Service provides luxury car rentals for weddings, corporate events, airport transfers, and VIP travel.",
    image: "/images/services/Luxury-Car-Rental-Service.jpg",
    link: "/luxury-car-rental-service",
  },
  {
    id: 18,
    name: "Outstation Cab Service",
    desc: "Book Rising Cab Service's outstation taxi service for safe, affordable, and comfortable long-distance journeys.",
    image: "/images/services/Outstation-Cab-Service.jpg",
    link: "/outstation-cab-service",
  },
];

const Service = () => {
  return (
    <>
     <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1, }}></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Services</h1>
          </div>
        </div>
      </div>


     

      <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
        <div className="container">
          <div className="section-content">
            <div className="twm-cars-section m-b30">
              <div className="row">
                {vehicles.map((vehicle) => (
                  <div
                    key={vehicle.id}
                    className="col-lg-4 col-md-6 m-b30 wow fadeInDown"
                    data-wow-delay="0.2s"
                  >
                    <div className="twm-vehicle-fleet-bx twm-custom-grid-3 ">
                      <div className="twm-media twmtitle">
                        <div className="twm-media-pi borderrr twmtitle text-center">
                          <img src={vehicle.image} alt={vehicle.name} />
                        </div>
                      </div>
                      <div className="twm-vehicle-fleet-content ">
                        <h3 className="twm-v-title twmtitle twmtitle text-center">
                          <a className="twmtitle text-center darkcolo" >{vehicle.name}</a>
                        </h3>
                        <ul className="twm-vehicle-facility">
                          <li>{vehicle.desc}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;